import { createSlice } from "@reduxjs/toolkit";
import { State } from "store/state";

const initialState = {
  isPopupOpen: true,
  showId: "",
};

export const selectPopupVisibility = (state: State) =>
  state.glossaryPopupTermSlice.isPopupOpen;
export const selectShowId = (state: State) =>
  state.glossaryPopupTermSlice.showId;

const glossaryPopupTermSlice = createSlice({
  name: "showGlossaryPopup",
  initialState,
  reducers: {
    updatePopupVisibility: (state, { payload }: { payload: boolean }) => ({
      ...state,
      isPopupOpen: payload,
    }),
    setShowId: (state, { payload }: { payload: string }) => ({
      ...state,
      showId: payload,
    }),
  },
});

export const {
  updatePopupVisibility,
  setShowId,
} = glossaryPopupTermSlice.actions;
export default glossaryPopupTermSlice.reducer;
